module.exports = __webpack_public_path__ + "static/media/Toxapex_gaussian2.d80948cb.png";